import isPhoneView from './isPhoneView';

export default isPhoneView;
